import React, { useState } from "react";
import { Box, Button, Tab, Tabs } from "@mui/material";
import { useNavigate } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import AddRating from "../../../Modals/addReplyRating";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MyOrders: React.FC = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  // Sample data for ongoing orders
  const ongoingOrders = [
    {
      id: 1,
      thumbnail: "/static/images/placeholder.png",
      serviceName: "Product Description Bundle (20 Items)",
      description:
        "High-quality English & Arabic product descriptions crafted to boost conversions and improve SEO ranking.",
      providerName: "Creative Content Ltd.",
      date: "2025-12-05",
      time: "14:00",
      deliveryDays: 2,
      price: 250,
      status: "Pending",
      paymentStatus: "Paid",
    },
    {
      id: 2,
      thumbnail: "/static/images/placeholder.png",
      serviceName: "Monthly Blog Writing (12 Blogs)",
      description:
        "Professionally researched and SEO-optimized blogs to increase organic traffic and strengthen brand authority.",
      providerName: "BlogMasters",
      date: "2025-12-10",
      time: "10:00",
      deliveryDays: 7,
      price: 850,
      status: "Accepted",
      paymentStatus: "Paid",
    },
    {
      id: 3,
      thumbnail: "/static/images/placeholder.png",
      serviceName: "Social Media Captions Package (40 Captions)",
      description:
        "Creative, engaging captions for Facebook, Instagram & TikTok written to increase engagement and impressions.",
      providerName: "SocialGurus",
      date: "2025-12-07",
      time: "09:30",
      deliveryDays: 3,
      price: 180,
      status: "In Progress",
      paymentStatus: "Pending",
    },
  ];

  // Sample data for past orders
  const pastOrders = [
    {
      id: 4,
      thumbnail: "/static/images/placeholder.png",
      serviceName: "Website Content (5 Pages)",
      description:
        "Professional content for Home, About, Services, Contact & more — fully SEO-ready and brand-aligned.",
      providerName: "WebContentPro",
      date: "2025-11-20",
      time: "15:00",
      deliveryDays: 5,
      price: 700,
      status: "Completed",
      paymentStatus: "Paid",
    },
    {
      id: 5,
      thumbnail: "/static/images/placeholder.png",
      serviceName: "Ad Copywriting Package (10 Ads)",
      description:
        "High-converting ad copies for Google, Meta, and TikTok — crafted to maximize CTR and customer acquisition.",
      providerName: "AdExperts",
      date: "2025-11-18",
      time: "11:00",
      deliveryDays: 1,
      price: 150,
      status: "Cancelled",
      paymentStatus: "Refunded",
    },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Service History</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Service History
        </p>
      </div>

      <div className="cards">
        <div className="custom_tabs1">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Ongoing Orders" {...a11yProps(0)} />
            <Tab label="Past Orders" {...a11yProps(1)} />
          </Tabs>
        </div>

        <div className="book_service">
          {(value === 0 ? ongoingOrders : pastOrders).map((order) => (
            <div className="book_inner" key={order.id}>
              <figure>
                <img src={order.thumbnail} alt="icon" />
              </figure>
              <h3>{order.serviceName}</h3>
              <p>{order.description}</p>

              <p>
                <b>Provider:</b> {order.providerName}
              </p>
              <p>
                <b>Date:</b> {order.date} &nbsp;|&nbsp; <b>Time:</b>{" "}
                {order.time}
              </p>

              <div className="time">
                <p>{order.deliveryDays} days delivery</p>
                <h4 className="price">AED {order.price}</h4>
              </div>

              <p>
                <b>Status:</b>{" "}
                <span
                  style={{
                    color:
                      order.status === "Pending"
                        ? "#FF9800"
                        : order.status === "Accepted"
                          ? "#2196F3"
                          : order.status === "In Progress"
                            ? "#1976d2"
                            : order.status === "Completed"
                              ? "#4caf50"
                              : "#f44336",
                  }}
                >
                  {order.status}
                </span>
              </p>
              <p>
                <b>Payment:</b>{" "}
                <span
                  style={{
                    color:
                      order.paymentStatus === "Paid"
                        ? "#4caf50"
                        : order.paymentStatus === "Pending"
                          ? "#ff9800"
                          : order.paymentStatus === "Refunded"
                            ? "#f44336"
                            : "#000000",
                  }}
                >
                  {order.paymentStatus}
                </span>
              </p>

              {value === 0 ? (
                <>
                  <Button
                    className="btn btn_grey sm "
                    onClick={() => navigate("view")}
                  >
                    View Service
                  </Button>
                  <Button
                    className="btn btn_primary sm mt_10"
                    onClick={() => navigate("/Manage-chat")}
                  >
                    Chat with Provider
                  </Button>


                  {(order.status === "Pending" ||
                    order.status === "Accepted") && (
                      <Button
                        variant="outlined"
                        className="btn mt_10 sm"
                        onClick={() => {
                          if (
                            window.confirm(
                              `Cancel booking for order #${order.id}?`
                            )
                          ) {
                            // Cancel logic here
                            alert("Booking cancelled");
                          }
                        }}
                      >
                        Cancel Booking
                      </Button>
                    )}
                </>
              ) : (
                <>
                  <Button
                    className="btn btn_grey sm "
                    onClick={() => navigate("view")}
                  >
                    View Service
                  </Button>
                  <Button className="btn btn_primary mt_10 sm" disabled>
                    Completed
                  </Button>
                  <Button
                    onClick={() => setOpenModal(true)}
                    variant="outlined"
                    className="btn btn_primary mt_10 sm"
                    startIcon={<StarIcon />}
                  >
                    Rate Provider
                  </Button>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
      <AddRating
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default MyOrders;
